import {
  useMemo,
} from 'react';
import type {
  ReactElement,
} from 'react';

import {
  Paginator as PaginatorBase,
} from '@vtaits/react-paginator';
import type {
  HrefBuilder,
  OnPageChange,
} from '@vtaits/react-paginator';

import { getPages } from './getPages';

import { components } from './components';
import { styles } from './styles';

import type {
  PaginatorPayload,
} from './types';

export const pageRangeDisplayed = 5;
export const marginPagesDisplayed = 1;

export const previousLabel = 'Пред.';
export const nextLabel = 'След.';

export const breakLabel = '...';

export type PaginatorProps = {
  /**
   * Текущая страница пагинатора, начиная с 1
   */
  page: number;
  /**
   * Количество страниц
   */
  pageCount: number;

  /**
   * Функция генерации атрибута href компонента <a>
   * @param {number} page - номер страницы, начиная с 1
   */
  hrefBuilder?: HrefBuilder;

  /**
   * Обработчик изменения страницы
   * @param {number} page - номер страницы, начиная с 1
   */
  onPageChange: OnPageChange;

  /**
   * id корневого dom-элемента
   */
  wrapperId?: string;
};

export function Paginator({
  page,
  pageCount,
  hrefBuilder = undefined,
  onPageChange,
  wrapperId = '',
}: PaginatorProps): ReactElement {
  const isOnePage = pageCount === 1;

  const payload = useMemo<PaginatorPayload>(() => ({
    isOnePage,
    wrapperId,
  }), [
    isOnePage,
    wrapperId,
  ]);

  return (
    <PaginatorBase
      page={page}
      pageCount={pageCount}
      hrefBuilder={hrefBuilder}
      onPageChange={onPageChange}
      pageRangeDisplayed={pageRangeDisplayed}
      marginPagesDisplayed={marginPagesDisplayed}
      previousLabel={previousLabel}
      nextLabel={nextLabel}
      breakLabel={breakLabel}
      components={components}
      styles={styles}
      getPages={getPages}
      payload={payload}
    />
  );
}
